import { render, staticRenderFns } from "./StarterNavbar.vue?vue&type=template&id=6c40de32&scoped=true&"
import script from "./StarterNavbar.vue?vue&type=script&lang=js&"
export * from "./StarterNavbar.vue?vue&type=script&lang=js&"
import style0 from "./StarterNavbar.vue?vue&type=style&index=0&id=6c40de32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c40de32",
  null
  
)

export default component.exports